var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticStyle:{"margin-bottom":"1.5%"},attrs:{"transition":"","searchable":true,"id":_vm.index+'_icd_'+_vm.appointmentId,"reduce":s => s.id,"label":"name","options":_vm.icdList},on:{"search":_vm.getIcdList},model:{value:(_vm.selectedIcd10Code),callback:function ($$v) {_vm.selectedIcd10Code=$$v},expression:"selectedIcd10Code"}})
}
var staticRenderFns = []

export { render, staticRenderFns }